import React from "react";
import PlusInformationBtn from "../../../../ui/Button/PlusInformationBtn";
import styles from "./style.module.css";

function ConsultantComponent(props: any) {
  return (
    <div className={styles.card}>
      {/* <span className={styles.title}>
            <img
                src={props.logo}
                alt="phoneIcon"
                style={{width: '20px', height: '20px'}}
                />
            <p className={styles.titre}>{props.titre}</p>
        </span> */}
      <PlusInformationBtn
        title={props.titre}
        message={props.subTitle2}
        phoneNumber={props.numberPhone}
        styleClass={styles.btnStyle}
      />
      <div className={styles.content}>
        <span>{props.subTitle1}</span>
      </div>
    </div>
  );
}

export default ConsultantComponent;
